// SSVC decision points and the CISA coordinator tree, for the review page —
// the same table as libvinnie/ssvc_review_flags.py and ssvc_guide.txt.

export const POINTS = ["E", "A", "T"];
export const POINT_LABELS = { E: "Exploitation", A: "Automatable", T: "Technical Impact" };
export const VALUE_ORDER = { E: ["N", "P", "A"], A: ["N", "Y"], T: ["P", "T"] };
export const VALUE_LABELS = {
  E: { N: "None", P: "Public PoC", A: "Active" },
  A: { N: "No", Y: "Yes" },
  T: { P: "Partial", T: "Total" },
};
export const OUTCOMES = ["Track", "Track*", "Attend", "Act"];
export const OUTCOME_COLORS = { Track: "#44bb44", "Track*": "#ffcc00", Attend: "#ff8800", Act: "#ff4444" };

const TREE = {
  NNP: "Track", NNT: "Track", NYP: "Track", NYT: "Track*",
  PNP: "Track", PNT: "Track*", PYP: "Track*", PYT: "Attend",
  ANP: "Track*", ANT: "Attend", AYP: "Attend", AYT: "Act",
};

export function outcome(m) {
  return m ? TREE[`${m.E}${m.A}${m.T}`] : null;
}

export function parseSsvc(vector) {
  if (!vector) return null;
  const parts = {};
  for (const seg of vector.replace(/^SSVCv2\//i, "").split("/")) {
    const [k, v] = seg.split(":");
    if (POINTS.includes(k) && VALUE_ORDER[k].includes(v)) parts[k] = v;
    if (k === "P") parts.P = v;
  }
  return POINTS.every((k) => parts[k]) ? parts : null;
}

export function formatSsvc(m) {
  return `SSVCv2/E:${m.E}/A:${m.A}/T:${m.T}/P:${outcome(m)}`;
}
